import React from 'react'
import { useTranslation } from 'react-i18next'
import { PageSection } from '../../../../shared/ui/PageSection'
import cls from './AboutSection.module.scss'

const AboutSection: React.FC = () => {
    const { t } = useTranslation()

    return (
        <PageSection
            title={t('about.title')}
            style={{ backgroundColor: '#f4f2e8' }}
        >
            <p className={cls.lead}>{t('about.text')}</p>
        </PageSection>
    )
}

export default AboutSection
